const FETCH_CSV_REQUEST = 'FETCH_CSV_REQUEST';
const FETCH_CSV_SUCCESS = 'FETCH_CSV_SUCCESS';
const FETCH_CSV_FAILURE = 'FETCH_CSV_FAILURE';
const CLEAR_CSV = 'CLEAR_CSV';

export {
  FETCH_CSV_REQUEST,
  FETCH_CSV_SUCCESS,
  FETCH_CSV_FAILURE,
  CLEAR_CSV,
};
